export const META_URL = "meta";
export const metaByIdUrl = (id) => `meta/${id}`;
export const metaBySlugUrl = (slug) => `meta/slug/${slug}`;
